import type { FaireProductEntity } from "../../entity_types/product";

export const p_xz8fau7e2u: FaireProductEntity = {
  token: "p_xz8fau7e2u",
  type: "product",
  name: "Custom Business Logo Wood Sign",
  brandToken: "b_191br80oqs",
  brandName: "The Cotton & Canvas Co.",
  imageUrl: "https://cdn.faire.com/fastly/f88772befa4b76e8a0b018d005565e97a64eb5fef6348c6561941aab56a66629.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/69a70147be2b398a15e5f84dfcb1ff945bfe418f69969dd78b0dd4509f82e134.jpeg",
    "https://cdn.faire.com/fastly/8747b01dec6a7d414e4e7531bfdf61d4c033f191d07bc9b55d5c9b5a6a2c13ff.jpeg",
    "https://cdn.faire.com/fastly/9a661fc2639dda6f7beb67f9c45bb151b8531ee9db5e121dbc4c7df6565de0bf.jpeg"
  ],
  priceDollars: 7.5,
  description: "To purchase, kindly place your order and send us a direct message with your artwork. A proof available upon request.\n\nCustomize this item with your artwork, logo or design!\n\nSimply submit your artwork and we'll print it for you! We kindly request the artwork to be in high resolution format. A PDF, EPS, PSD, or AI file is required to ensure the print is sharp and not pixelated. JPGs above 1000 pixels can be accepted.\n\nEngraved on high quality wood material, these wooden discs make the perfect addition to your social media flat lay photos, branding images, and office décor!\n\n• Material: Natural Maple Wood\n• Dimensions: Choose from 4\", 12\" and 24\" in Diameter\n• Design is engraved on the front side\n• Designed and manufactured in the USA. Copyright The Cotton & Canvas Co.\n\nAll personalized item sales are final. Personalized items are non-refundable.",
  tags: [],
  msrpDollars: 14.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T08:03:44.469Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
